<script>
    import * as m from '@app/paraglide/messages.js';
    import {
        videoFilterState, resetVideoFilters
    } from '@app/store/videoFilterStore.svelte.js';
    import {projectState} from '@app/store/projectStore.svelte.js';
    import { onMount } from 'svelte';

    let videoPlayerEl = $state(null);
    let zoomLevel = $state(1);
    let leftOffset = $state(0);
    let topOffset = $state(0);
        
    onMount(() => {
        videoPlayerEl = document.getElementsByTagName("video")[0];
    });

    $effect(() => {
        // console.log("EFFECT update zoom level")
        if (videoPlayerEl && zoomLevel) {
            updateZoomLevel(zoomLevel);
        }
    });

    $effect(() => {
        // console.log("EFFECT update top offset")
        if (videoPlayerEl && topOffset !== undefined) {
            updateTopOffset(topOffset);
        }
    });

    $effect(() => {
        // console.log("EFFECT update left offset");
        if (videoPlayerEl && leftOffset !== undefined) {
            updateLeftOffset(leftOffset);
        }
    });
    
    function resetFilters(){
        resetVideoFilters();
        zoomLevel = 1, leftOffset = 0, topOffset = 0;    
    }

    function updateZoomLevel(level){
        videoPlayerEl = videoPlayerEl ? videoPlayerEl : document.getElementsByTagName("video")[0];
        if (videoPlayerEl){
            videoPlayerEl.style.scale = level;
        }
    }

    function updateTopOffset(offset){
        videoPlayerEl = videoPlayerEl ? videoPlayerEl : document.getElementsByTagName("video")[0];
        if (videoPlayerEl){
            videoPlayerEl.style.position = "relative";
            videoPlayerEl.style.top = offset+"px";
        }
    }

    function updateLeftOffset(offset){
        videoPlayerEl = videoPlayerEl ? videoPlayerEl : document.getElementsByTagName("video")[0];
        if (videoPlayerEl){
            videoPlayerEl.style.position = "relative";
            videoPlayerEl.style.left = offset+"px";
        }
    }
</script>

<form id="videoFiltersForm" aria-label={m.video_filters_form_aria_label()} class="p-1">
    <div class="row">
        <div class="col-3">
            <label for="brightnessFilterRange" class="form-label">{m.video_filters_brightness_label()}</label>
            <input type="range" class="form-range" id="brightnessFilterRange" min=0 max=250 bind:value={videoFilterState.brightness} ondblclick={() => videoFilterState.brightness=100} disabled={projectState.media.storage === "Vimeo" || projectState.media.storage === "YouTube"}>
        </div>
        <div class="col-3">
            <label for="contrastFilterRange" class="form-label">{m.video_filters_contrast_label()}</label>
            <input type="range" class="form-range" id="contrastFilterRange" min=0 max=250 bind:value={videoFilterState.contrast} ondblclick={() => videoFilterState.contrast=100} disabled={projectState.media.storage === "Vimeo" || projectState.media.storage === "YouTube"}>
        </div>
        <div class="col-3">
            <label for="saturationFilterRange" class="form-label">{m.video_filters_saturation_label()}</label>
            <input type="range" class="form-range" id="saturationFilterRange" min=0 max=250 bind:value={videoFilterState.saturation} ondblclick={() => videoFilterState.saturation=100} disabled={projectState.media.storage === "Vimeo" || projectState.media.storage === "YouTube"}>
        </div>
        <div class="col-3">
            <label for="invertFilterRange" class="form-label">{m.video_filters_invert_label()}</label>
            <input type="range" class="form-range" id="invertFilterRange" min=0 max=100 bind:value={videoFilterState.invert} ondblclick={() => videoFilterState.invert=0} disabled={projectState.media.storage === "Vimeo" || projectState.media.storage === "YouTube"}>
        </div>
    </div>
    <hr class="my-2"/>
    <div class="row mb-2">
        <div class="col-6">
            <label for="zoomRange" class="form-label">{m.video_filters_zoom_label()}</label>
            <input type="range" class="form-range" id="zoomRange" min="0" max="5" step="0.01" bind:value={zoomLevel} ondblclick={() => zoomLevel=1} disabled={projectState.media.storage === "Vimeo" || projectState.media.storage === "YouTube"}>
        </div>
        <div class="col-3">
            <label for="topOffsetRange" class="form-label">{m.video_filters_y_offset_label()}</label>
            <input type="range" class="form-range" id="topOffsetRange" min="-1000" max="1000" step="1" bind:value={topOffset} ondblclick={() => topOffset=0} disabled={projectState.media.storage === "Vimeo" || projectState.media.storage === "YouTube"}>
        </div>
        <div class="col-3">
            <label for="leftOffsetRange" class="form-label">{m.video_filters_x_offset_label()}</label>
            <input type="range" class="form-range" id="leftOffsetRange" min="-1000" max="1000" step="1" bind:value={leftOffset} ondblclick={() => leftOffset=0} disabled={projectState.media.storage === "Vimeo" || projectState.media.storage === "YouTube"}>
        </div>
    </div>
    {#if projectState.media.storage === "Vimeo" || projectState.media.storage === "YouTube"}
        <p class="text-danger small">{m.video_filters_unavailable_message()}</p>
    {/if}
    <button
        id="resetFiltersBtn"
        aria-label={m.video_filters_reset_aria_label()}
        type="button"
        title={m.video_filters_reset_title()}
        class='btn btn-primary btn-sm'
        onclick={() => resetFilters()}
        disabled={projectState.media.storage === 'Vimeo' || projectState.media.storage === 'YouTube'}>
        <i class="bi bi-arrow-clockwise"></i> {m.video_filters_reset_button()}
    </button>
</form>

<style lang="css">
</style>
